import { Button } from "@design-system/Button/Button";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { HStack } from "@design-system/HStack/HStack";
import { ArrowRightIcon, CloseIcon } from "@icons";
import { ThreadWithWorkspaceName } from "@common/schemas/chat.schema";
import { StateAwareNavLink } from "@components/routes/StateAwareNavLink";
import styles from "./Chat.module.scss";

interface ChatThreadHeaderProps {
    selectedThread: ThreadWithWorkspaceName;
    isOrganizationChat: boolean;
    titleLink?: string;
    onBack: () => void;
    onClose: () => void;
}

export const ChatThreadHeader = ({
    selectedThread,
    isOrganizationChat,
    titleLink,
    onBack,
    onClose,
}: ChatThreadHeaderProps) => (
    <div className={styles.title}>
        <HStack gap={8} align="center" className={styles.titleBreadcrumb}>
            <Button variant="link" size="sm" onClick={onBack}>
                Chat
            </Button>
            <ArrowRightIcon className="icon-color-gray-500" />
            {isOrganizationChat && selectedThread.workspaceName ? (
                <>
                    <BreakableText
                        text={selectedThread.workspaceName}
                        className={styles.titleClientName}
                        showTooltip
                    />
                    <ArrowRightIcon className="icon-color-gray-500" />
                </>
            ) : null}
            <StateAwareNavLink
                to={titleLink ?? `/?taskId=${selectedThread.taskId}`}
                onClick={onClose}
                className={styles.titleText}
            >
                <Button variant="link" size="sm" onClick={onBack}>
                    <BreakableText
                        text={selectedThread.title}
                        className={styles.titleText}
                    />
                </Button>
            </StateAwareNavLink>
        </HStack>

        <Button
            iconOnly
            variant="primary"
            size="sm"
            onClick={onClose}
            aria-label="Close chat"
        >
            <CloseIcon />
        </Button>
    </div>
);
